<div class="modal-content">
    <div class="modal-header justify-content-center">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
          <i class="nc-icon nc-simple-remove"></i>
      </button>
        <h5 class="title title-up">{{ title }}</h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="card card-plain">
                <div class="card-header" role="tab" id="headingOne">
                    <span data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      Digite as informações abaixo para criar a Unidade Operacional
                  </span>
                </div>
                <div class="card-body">
                    <form [formGroup]="form">
                        <div class="row justify-content-center">
                            <!-- <div class="col-md-4">
                                <label for="">Número da Unidade</label>
                                <div class="form-group">
                                    <input type="number" class="form-control text-center" placeholder="Informe o número da Unidade" formControlName="cD_BPM_NR_UNIDADE" [ngClass]="{
                                      'is-invalid':
                                        form.controls.cD_BPM_NR_UNIDADE.errors?.required &&
                                        form.controls.cD_BPM_NR_UNIDADE.touched
                                    }" required>
                                </div>

                            </div> -->
                            <div class="col-md-4">
                                <label for="">Unidade</label>
                                <div class="form-group">
                                    <input type="text" class="form-control text-center" placeholder="Informe a Unidade" formControlName="dS_BPM_UNIDADE" [ngClass]="{
                                      'is-invalid':
                                        form.controls.dS_BPM_UNIDADE.errors?.required &&
                                        form.controls.dS_BPM_UNIDADE.touched
                                    }" required>
                                </div>

                            </div>
                            <!---
                                <div class="col-md-4">
                                    <label for="Uf">UF</label>
                                    <div class="form-group inputWithIcon">
                                      <select type="text" class="form-control custom-select text-center" formControlName="dS_BPM_UF_UNIDADE" id="Uf" (click)="getMunicipio()" [ngClass]="{
                                          'is-invalid':
                                            form.controls.dS_BPM_UF_UNIDADE.errors?.required &&
                                            form.controls.dS_BPM_UF_UNIDADE.touched
                                        }" required>
                                        <option value="{{i}}" *ngFor="let i of ufLocalizacao">{{i}}</option>
                                      </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="Municipio">Municipio</label>
                                    <div class="form-group inputWithIcon">
                                      <select type="text" class="form-control custom-select text-center" formControlName="dS_BPM_MUNICIPIO_UNIDADE" id="Municipio" (select)="selectMun($event)" [ngClass]="{
                                          'is-invalid':
                                            form.controls.dS_BPM_MUNICIPIO_UNIDADE.errors?.required &&
                                            form.controls.dS_BPM_MUNICIPIO_UNIDADE.touched
                                        }" required>
                                        <option value="{{e}}" *ngFor="let e of municipiosOrigem">{{e}}</option>
                                      </select>
                                    </div>
                                </div>-->

                                
                                    <div class="col-md-4">
                                      <label for="origemUf">UF</label>
                                      <div class="form-group inputWithIcon">
                                        <select type="text" class="form-control custom-select text-center" formControlName="dS_BPM_UF_UNIDADE" id="origemUf" (click)=" getMunicipioOrigem()" [ngClass]="{
                                            'is-invalid':
                                              form.controls.dS_BPM_UF_UNIDADE.errors?.required &&
                                              form.controls.dS_BPM_UF_UNIDADE.touched
                                          }" required>
                                        <option value="{{i}}" *ngFor="let i of ufOrigem">{{i}}</option>
                                        </select>
                                          <i class="fa fa-exclamation-circle fa-lg fa-fw" aria-hidden="true" *ngIf="form.controls.dS_BPM_UF_UNIDADE.errors?.required &&
                                          form.controls.dS_BPM_UF_UNIDADE.touched" title="Qual local de saída?"></i>
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <label for="origemMunicipio">Municipio</label>
                                      <div class="form-group inputWithIcon">
                                        <select type="text" class="form-control custom-select text-center"  formControlName="dS_BPM_MUNICIPIO_UNIDADE" id="origemMunicipio" (select)="selectMun($event)"  [ngClass]="{
                                            'is-invalid':
                                              form.controls.dS_BPM_MUNICIPIO_UNIDADE.errors?.required &&
                                              form.controls.dS_BPM_MUNICIPIO_UNIDADE.touched
                                          }" required>
                                          <option value="{{e}}" *ngFor="let e of municipiosOrigem">
                                            {{e}}</option>
                                        </select>
                                          <i class="fa fa-exclamation-circle fa-lg fa-fw" aria-hidden="true" *ngIf="form.controls.dS_BPM_MUNICIPIO_UNIDADE.errors?.required &&
                                          form.controls.dS_BPM_MUNICIPIO_UNIDADE.touched" title="Qual local de chegada?"></i>
                                      </div>
                                    </div>

                            <div class="col-md-4">
                                <label for="">Endereço</label>
                                <div class="form-group">
                                    <input type="text" class="form-control text-center" placeholder="Endereço" formControlName="dS_BPM_ENDERECO_UNIDADE" [ngClass]="{
                                      'is-invalid':
                                        form.controls.dS_BPM_ENDERECO_UNIDADE.errors?.required &&
                                        form.controls.dS_BPM_ENDERECO_UNIDADE.touched
                                    }" required>
                                </div>

                            </div>
                            <div class="col-md-4 ">
                                <label>Ativo</label>
                                <div class="form-group text-center">
                                    <select formControlName="fL_BPM_ATIVO" class="form-control custom-select text-center" aria-label="Small">
                                      <option selected disabled>Ativo</option>
                                      <option value="1">Sim</option>
                                      <option value="0">Não</option>
                                  </select>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="row">
                        <div class="col-md-12 text-center" *ngIf="loading">
                            <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!loading" class="modal-footer">
        <div class="left-side">
            <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close()">
              Cancelar
          </button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
            <button type="button" [disabled]="!form.valid" class="btn btn-success btn-link" (click)="submit()">
              Salvar
          </button>
        </div>
    </div>
</div>